export default {
  baseUrl: 'https://softech.cloud',
};

export const allowedEmailDomains = ['ames.edu.vn', 'teky.edu.vn'];
